import BigNumber from "bignumber.js";

export default function bnParseUnits(value: BigNumber.Value, decimals: BigNumber.Value): BigNumber {
  return bn(value||0).times(bn(10).pow(decimals||0)).idiv(1)
}

function bn(value: BigNumber.Value) {
  return new BigNumber(value)
}